import React, { useEffect, useRef, useState } from 'react'
import useSound from 'use-sound'

import neomjoin from '../../../assets/sounds/neomjoin.mp3'
import rainbowjoin from '../../../assets/sounds/rainbowjoin.mp3'
import onicjoin from '../../../assets/sounds/onicjoin.mp3'
import thebitjoin from '../../../assets/sounds/thebitjoin.mp3'
import message3 from '../../../assets/sounds/message3.mp3'



// 기존 모의신청 + 가입신청 -> 변경 SoundRepeat3 : 모의신청 , SoundRepeat6 : 가입신청
const SoundRepeat6 = ({text=''}) => { 

//	const [bell, setBell] = useState<string | null>(null);
	const [refresh, setRefresh] = useState(false);

	// useEffect(() => {
	// 	const loadSound = async () => {
	// 	  let sound;
	// 	  if (process.env.REACT_APP_NAME === 'NEOM') {
	// 		sound = await import('../../../assets/sounds/neomjoin.mp3');
	// 	  } else if (process.env.REACT_APP_NAME === 'RAINBOW') {
	// 		sound = await import('../../../assets/sounds/rainbowjoin.mp3');
	// 	  } else if (process.env.REACT_APP_NAME === 'ONIC') {
	// 		sound = await import('../../../assets/sounds/onicjoin.mp3');
	// 	  } else { // 기본
	// 		sound = await import('../../../assets/sounds/message3.mp3'); // 다른 경로 예시
	// 	  }
	// 	  setBell(sound.default);
	// 	};
	
	// 	loadSound();
	//   }, []);

	let bell = message3

	if (process.env.REACT_APP_NAME === 'NEOM') {
		bell = neomjoin
	 } else if (process.env.REACT_APP_NAME === 'RAINBOW') {
	   bell = rainbowjoin;
	 } else if (process.env.REACT_APP_NAME === 'ONIC') {
	   bell = onicjoin
	 } else if( process.env.REACT_APP_NAME === 'THEBIT') {
	   bell = thebitjoin		
	 }else { // 기본
	   bell =  message3
	 }
	 console.log("SOUND", process.env.REACT_APP_NAME);

	  
	const [play, { stop }] = useSound(bell || '', { interrupt: true, volume:process.env.REACT_APP_NAME === 'ONIC'?0.6:1  });

	useEffect(() => {
		  console.log("PLAY6");
		  play({
			forceSoundEnabled: true,
		  });
		  setTimeout(() => {
			setRefresh(!refresh);
		}, 60*1000*5)
	  }, [refresh]);
	
	  useEffect(() => {
		setTimeout(() => {
		  setRefresh(!refresh);
		}, 200);
	
		return () => {
		  stop();
		};
	  }, [stop]);

	return <>{''}</>
}
export default SoundRepeat6
